import { z } from 'zod';

import { ISSUE_PRIORITY, ISSUE_TYPE } from '../enums';

import { idSchema } from './common';

export const issueTypeSchema = z.enum([
  ISSUE_TYPE.STORY,
  ISSUE_TYPE.TASK,
  ISSUE_TYPE.BUG,
  ISSUE_TYPE.SUBTASK,
]);

export const issuePrioritySchema = z.enum([
  ISSUE_PRIORITY.LOWEST,
  ISSUE_PRIORITY.LOW,
  ISSUE_PRIORITY.MEDIUM,
  ISSUE_PRIORITY.HIGH,
  ISSUE_PRIORITY.HIGHEST,
]);

export const createIssueInputSchema = z.object({
  type: issueTypeSchema,
  title: z.string().trim().min(1).max(200),
  descriptionMarkdown: z.string().max(50_000).optional(),
  assigneeId: idSchema.nullable().optional(),
  parentIssueId: idSchema.nullable().optional(),
  priority: issuePrioritySchema.default(ISSUE_PRIORITY.MEDIUM),
  storyPoints: z.number().int().min(0).max(999).nullable().optional(),
  sprintId: idSchema.nullable().optional(),
});
export type CreateIssueInput = z.infer<typeof createIssueInputSchema>;

export const updateIssueInputSchema = z.object({
  title: z.string().trim().min(1).max(200).optional(),
  descriptionMarkdown: z.string().max(50_000).nullable().optional(),
  statusId: idSchema.optional(),
  assigneeId: idSchema.nullable().optional(),
  priority: issuePrioritySchema.optional(),
  storyPoints: z.number().int().min(0).max(999).nullable().optional(),
  sprintId: idSchema.nullable().optional(),
  parentIssueId: idSchema.nullable().optional(),
});
export type UpdateIssueInput = z.infer<typeof updateIssueInputSchema>;

export const issueSummarySchema = z.object({
  id: idSchema,
  key: z.string(),
  title: z.string(),
  type: issueTypeSchema,
  priority: issuePrioritySchema,
  statusId: idSchema,
  assigneeId: idSchema.nullable(),
  storyPoints: z.number().int().nullable(),
  updatedAt: z.string(),
});
export type IssueSummary = z.infer<typeof issueSummarySchema>;
